import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

// === Класс валидации телефона ===
class PhoneValidator {
  constructor(phoneInput) {
    this.phoneInput = phoneInput;
    this.errorField =
      this.phoneInput.closest(".form__input")?.querySelector(".error__field") ||
      null;

    this.isValid = false;
    this.isTouched = false;

    this.init();
  }

  init() {
    if (!this.phoneInput) return;

    this.phoneInput.addEventListener("input", (e) => this.handleInput(e));
    this.phoneInput.addEventListener("paste", (e) => this.handlePaste(e));
    this.phoneInput.addEventListener("blur", () => {
      this.isTouched = true;
      this.validate(true);
    });
  }

  formatNumber(value) {
    let numbersOnly = value.replace(/\D/g, "").slice(0, 11);

    if (numbersOnly.startsWith("8")) {
      numbersOnly = numbersOnly.replace(/^8/, "7");
    } else if (numbersOnly.startsWith("9")) {
      numbersOnly = "7" + numbersOnly;
    }

    let formatted = "+7 ";
    if (numbersOnly.length > 1) {
      formatted += `(${numbersOnly.substring(1, 4)}`;
      if (numbersOnly.length >= 5)
        formatted += `) ${numbersOnly.substring(4, 7)}`;
      if (numbersOnly.length >= 8)
        formatted += `-${numbersOnly.substring(7, 9)}`;
      if (numbersOnly.length >= 10)
        formatted += `-${numbersOnly.substring(9, 11)}`;
    }

    return formatted;
  }

  handleInput(e) {
    const newValue = this.formatNumber(e.target.value);
    e.target.value = newValue;

    const numbersOnly = newValue.replace(/\D/g, "");
    this.validate(this.isTouched || numbersOnly.length === 11);
  }

  handlePaste(e) {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData(
      "text"
    );
    const numbersOnly = pastedText.replace(/\D/g, "");
    const currentValue = this.phoneInput.value.replace(/\D/g, "");

    const newValue =
      currentValue.slice(0, this.phoneInput.selectionStart) +
      numbersOnly +
      currentValue.slice(this.phoneInput.selectionEnd);

    const formattedValue = this.formatNumber(newValue);
    this.phoneInput.value = formattedValue;

    const newNumbersOnly = formattedValue.replace(/\D/g, "");
    this.validate(this.isTouched || newNumbersOnly.length === 11);
  }

  validate(shouldShowError) {
    const numbersOnly = this.phoneInput.value.replace(/\D/g, "");
    const isValid = numbersOnly.length === 11;

    const container = this.phoneInput.closest(".form__input");
    if (!container) return isValid;

    if (this.errorField) {
      this.errorField.style.display =
        isValid || !shouldShowError ? "none" : "block";
    }

    container.classList.toggle("invalid", !isValid && shouldShowError);
    this.phoneInput.classList.toggle("is-invalid", !isValid && shouldShowError);
    this.phoneInput.classList.toggle("is-valid", isValid);

    this.isValid = isValid;
    return isValid;
  }

  reset() {
    this.phoneInput.value = "";
    this.isValid = false;
    this.isTouched = false;

    this.phoneInput.classList.remove("is-invalid", "is-valid");

    const container = this.phoneInput.closest(".form__input");
    if (container) {
      container.classList.remove("invalid");
    }
  }
}

// === Класс отправки формы ===
class FormSubmitter {
  constructor(form, phoneValidator) {
    this.form = form;
    this.phoneValidator = phoneValidator;
    this.submitButtons = form.querySelectorAll("[type='submit']");
    this.checkbox = form.querySelector("input[name='agreement']");
    this.isFormTouched = false;

    this.init();
  }

  init() {
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));

    if (this.checkbox) {
      this.checkbox.addEventListener("change", () => {
        this.isFormTouched = true;
        this.updateSubmitButtonState();
      });
    }

    if (this.phoneValidator.phoneInput) {
      this.phoneValidator.phoneInput.addEventListener("blur", () => {
        this.isFormTouched = true;
        this.updateSubmitButtonState();
      });
    }

    this.updateSubmitButtonState();
  }

  isPhoneDirty() {
    return (
      this.phoneValidator.phoneInput &&
      this.phoneValidator.phoneInput.value.trim() !== ""
    );
  }

  updateSubmitButtonState() {
    if (!this.isFormTouched) {
      this.submitButtons.forEach((btn) => (btn.disabled = false));
      return;
    }

    const phoneIsRequired = this.isPhoneDirty();
    let phoneValid = true;

    if (phoneIsRequired) {
      phoneValid = this.phoneValidator.isValid;
    }

    const checkboxChecked = this.checkbox ? this.checkbox.checked : true;
    const isValid = phoneValid && checkboxChecked;

    this.submitButtons.forEach((btn) => (btn.disabled = !isValid));
  }

  handleSubmit(e) {
    e.preventDefault();

    this.isFormTouched = true;

    const phoneValid = this.phoneValidator.validate(true);
    const checkboxChecked = this.checkbox ? this.checkbox.checked : true;

    if (!phoneValid || !checkboxChecked) {
      if (!phoneValid) {
        this.phoneValidator.phoneInput.focus();
      }

      this.updateSubmitButtonState();
      return;
    }

    this.submitButtons.forEach((btn) => btn.setAttribute("disabled", true));

    const formData = new FormData(this.form);

    leadgets("lead", formData, (response) => {
      if (response.status === 1) {
        this.handleSuccess();
      } else {
        this.handleError();
      }
    });
  }

  handleSuccess() {
    Fancybox.close();
    this.resetForm();

    let autoCloseTimeout = null;

    setTimeout(() => {
      Fancybox.show([{ src: "#thanks_order", type: "inline" }], {
        hideClass: false,
        showClass: false,
        on: {
          close: () => {
            if (autoCloseTimeout) {
              clearTimeout(autoCloseTimeout);
              autoCloseTimeout = null;
            }
            this.forceUnlockPage();
          },
          destroy: () => {
            this.forceUnlockPage();
          },
        },
      });

      autoCloseTimeout = setTimeout(() => {
        Fancybox.close();
      }, 4000);
    }, 1000);
  }

  handleError() {
    this.submitButtons.forEach((btn) => btn.removeAttribute("disabled"));
    alert("Ошибка отправки. Попробуйте еще раз");
  }

  resetForm() {
    this.form.querySelectorAll("input, textarea").forEach((input) => {
      if (!["submit", "checkbox", "radio", "hidden"].includes(input.type)) {
        input.value = "";
        input.closest(".form__input")?.classList.remove("valid", "invalid");
      }
    });

    this.form.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      if (!["agreement", "aproved-policy"].includes(checkbox.name)) {
        checkbox.checked = false;
      }
    });

    if (this.checkbox) {
      this.checkbox.checked = true;
    }

    this.phoneValidator.reset();
    this.isFormTouched = false;
    this.updateSubmitButtonState();
  }

  forceUnlockPage() {
    document
      .querySelectorAll(".fancybox__backdrop, .fancybox-overlay")
      .forEach((el) => el.remove());
    document
      .querySelectorAll(".fancybox__container")
      .forEach((el) => el.remove());

    document.body.classList.remove(
      "is-fancybox-lock",
      "compensate-for-scrollbar"
    );
    document.documentElement.classList.remove("is-fancybox-lock");

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.body.style.pointerEvents = "";
    document.body.style.position = "";
    document.body.style.width = "";

    const lastFocus = document.querySelector("[data-fancybox-lastfocus]");
    if (lastFocus) {
      lastFocus.focus();
      lastFocus.removeAttribute("data-fancybox-lastfocus");
    }
  }
}

// === Инициализация форм ===
document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll("form.form_leadgets");

  forms.forEach((form) => {
    const phoneInput = form.querySelector("input[type='tel']");
    if (phoneInput) {
      const phoneValidator = new PhoneValidator(phoneInput);
      new FormSubmitter(form, phoneValidator);
    }
  });
});

// Корректный обработчик закрытия для thanks_order
document.addEventListener("DOMContentLoaded", function () {
  const closeButton = document.querySelector(
    ".modal__block__close[data-popup='thanks_order']"
  );
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      Fancybox.close();
    });
  }
});

// === Обработчик для динамических модалок ===
document.addEventListener("DOMContentLoaded", function () {
  const modalTitleField = document.getElementById("modal_title_field");
  const form = document.querySelector(".form_leadgets");

  const materialInput = form?.querySelector("input[name='material']");
  const squareInput = form?.querySelector("input[name='square']");
  const totalcostInput = form?.querySelector("input[name='totalcost']");

  function resetHiddenInputs() {
    if (modalTitleField) {
      modalTitleField.textContent = "Оставьте заявку на обратный звонок";
    }
    if (materialInput) materialInput.value = "";
    if (squareInput) squareInput.value = "";
    if (totalcostInput) totalcostInput.value = "";
  }

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("[data-fancybox]");
    if (!trigger) return;

    setTimeout(() => {
      resetHiddenInputs();

      const modalTitle = trigger.getAttribute("data-modal-title");
      if (modalTitle && modalTitleField) {
        modalTitleField.textContent = modalTitle;
      }

      if (materialInput) {
        const material = trigger.getAttribute("data-material");
        if (material) materialInput.value = material;
      }

      if (squareInput) {
        const square = trigger.getAttribute("data-square");
        if (square) squareInput.value = square;
      }

      if (totalcostInput) {
        const totalcost = trigger.getAttribute("data-totalcost");
        if (totalcost) totalcostInput.value = totalcost;
      }
    }, 50);
  });
});

// глобальная разблокировка на случай сбоев
document.addEventListener("click", function (e) {
  if (e.target.closest(".modal__block__close[data-popup='thanks_order']")) {
    setTimeout(() => {
      document
        .querySelectorAll(".fancybox__backdrop, .fancybox__container")
        .forEach((el) => el.remove());
      document.body.classList.remove(
        "is-fancybox-lock",
        "compensate-for-scrollbar"
      );
      document.body.style.cssText = "";
      document.documentElement.classList.remove("is-fancybox-lock");

      if (typeof Fancybox !== "undefined" && Fancybox.instance) {
        Fancybox.close();
      }
    }, 10);
  }
});
